import { haveDateLoaded } from 'constants/operations';
import API from 'constants/api';
import { select, put, all, takeLatest, call } from 'redux-saga/effects';
import { getData } from 'util/Api';
import { selectPackagesMassive } from './selectors';
import { actions } from './slice';

const URL = API.massive.list;

function* fetchSaga() {
  try {
    const {
      pageable: { pageNumber, pageSize },
      search,
      date,
    } = yield select(selectPackagesMassive);
    const searchParams = new URLSearchParams({
      page: pageNumber,
      size: pageSize,
      search,
      from: date.from,
      to: date.to,
      desc: true,
    });
    const request = yield call(getData, `${URL}?${searchParams.toString()}`);
    const payload = {
      items: request.content,
      total: request.numberOfElements,
    };
    yield put({ type: actions.success.type, payload });
  } catch (e) {
    yield put({ type: actions.failure.type });
  }
}

function* updateBasefilters() {
  const { date } = yield select(selectPackagesMassive);
  if (!haveDateLoaded(date)) {
    return;
  }
  yield put({
    type: actions.fetch.type,
  });
}

export default function* rootSaga() {
  yield all([
    takeLatest(
      [
        actions.updatePaginate,
        actions.updateSearch,
        actions.refreshPage,
        actions.resetFilters,
        actions.updateDate,
      ],
      updateBasefilters,
    ),
    takeLatest(actions.fetch, fetchSaga),
  ]);
}
